/**
 * Enhances inspectorData with properties from fabricMetadata
 * by matching id values with fabricMetadata keys.
 * If a node with testID matching storyId is found, sets viewHierarchy
 * to point to the first child of that node.
 */
export function prepareInspectorData(inspectorData, fabricMetadata, storyId) {
    const { density } = inspectorData;
    const inspectorDataCopy = JSON.parse(JSON.stringify(inspectorData));
    let rootStoryNode = null;
    function enhanceNode(node) {
        if (!node)
            return;
        node.adjustedWidth = Math.round(node.width / density);
        node.adjustedHeight = Math.round(node.height / density);
        const metadataEntry = fabricMetadata.viewProps[node.id];
        if (metadataEntry) {
            const { className, ...properties } = metadataEntry;
            // className coming from native side can be obfuscated so if we have
            // access to the name from fiber we will use that instead
            if (className) {
                node.className = className;
            }
            node.properties = properties;
            // we need to find the root story node that will be the first node user can inspect
            // this is done to remove all boilerplate parent nodes from the hierarchy
            // like the ones injected by Sherlo
            if (node.properties.testID === storyId) {
                if (node.children && Array.isArray(node.children) && node.children.length > 0) {
                    rootStoryNode = node;
                }
            }
        }
        if (node.children && Array.isArray(node.children)) {
            node.children.forEach(enhanceNode);
        }
    }
    if (inspectorDataCopy.viewHierarchy) {
        enhanceNode(inspectorDataCopy.viewHierarchy);
        if (rootStoryNode) {
            inspectorDataCopy.viewHierarchy = rootStoryNode;
        }
    }
    return inspectorDataCopy;
}
//# sourceMappingURL=prepareInspectorData.js.map